<div
  class="right-section-wrapper"
  [ngClass]="{ open: sideSectionService.sideContainerType !== sideContainerType.NONE }"
>
  @if (sideSectionService.sideContainerType === sideContainerType.ACTION_MENU) {
    <app-social-menu [isHost]="isHost()" [user]="user()" [social]="social()"></app-social-menu>
  }
</div>
